import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PosCompensationBadgeService {
  private readonly refreshCounter = signal(0);

  readonly refreshTick = this.refreshCounter.asReadonly();

  requestRefresh(): void {
    this.refreshCounter.update((value) => value + 1);
  }
}
